import React, { useEffect, useRef, useState } from "react";
import "../css/Kare.css";

// 텍스트 데이터 (기존 내용 유지)
const KARE_TEXT = {
    // 1. 한국어 데이터
    ko: {
        hero: {
            line1: "가장 정직한 케어,",
            line2: "품격의 기준이 되다",
        },
        about: {
            title: "About Us",
            subtitle: "의료 우수성을 향한 프라이빗 게이트웨이.",
            desc1: "세계 최고 수준의 한국 의료 환경을 마주할 때, 당신에게 필요한 것은 단순한 정보가 아니라 신뢰할 수 있는 파트너입니다. K.ARE는 글로벌 환자와 한국의 최정상급 의료 인프라를 잇는 가장 견고한 가교가 되기 위해 설립되었습니다.",
            desc2: "K.ARE는 단순한 병원 예약을 넘어, 환자의 안전과 존엄을 최우선으로 하는 ‘메디컬 매니지먼트’를 지향합니다. 국가가 인증한 소수의 우수 의료기관만을 엄선하여, 암 치료와 같은 중증 질환부터 정교한 미용 시술까지, 그 어떤 여정에서도 타협하지 않는 최상의 기준을 제시합니다.",
            features: [
                {
                    icon: "/kare_img/2-1_img.png",
                    title: "검증된 네트워크",
                    desc: "임상 결과와 안전 프로토콜이 철저히 검증된 상급 의료기관만을 파트너로 합니다.",
                },
                {
                    icon: "/kare_img/2-2_img.png",
                    title: "환자 중심 가이드",
                    desc: "병원의 수익보다 환자의 관점을 우선합니다. 정직하고 투명한 정보를 통해 오직 환자에게 최선인 선택을 돕습니다.",
                },
                {
                    icon: "/kare_img/2-3_img.png",
                    title: "일원화 서비스",
                    desc: "어떤 진료 분야를 선택하시든, K.ARE라는 단일 채널을 통해 일관된 프리미엄 케어를 누리실 수 있습니다.",
                },
            ],
        },
        services: {
            title: "Services",
            parts: [
                {
                    part: "PART 01",
                    name: "정밀 검진",
                    intro: "모든 치료의 시작은 정확한 정보에서 시작됩니다. K.ARE는 AI 영상 판독과 다각적인 바이오마커 분석 등 한국의 최첨단 진단 시스템을 연결하여, 당신의 건강 상태를 가장 객관적이고 정밀하게 확인할 수 있도록 돕습니다.",
                    bullets: [
                        { title: "효율적인 검진 프로세스", desc: "단 하루 만에 모든 검사가 완료되는 프리미엄 원스톱 시스템을 통해 검진의 효율을 극대화합니다." },
                        { title: "전문의 상담을 통한 맞춤 솔루션", desc: "전문 통역이 포함된 리포트와 함께, 검사 결과에 따른 분야별 전문의가 향후 관리와 치료 방향에 대한 구체적인 로드맵을 제시하도록 지원합니다." },
                    ],
                },
                {
                    part: "PART 02",
                    name: "중증 질환 치료",
                    intro: "상급종합병원 연계를 통한 고난도 수술 및 집중 치료. 중증 질환은 의료진의 숙련도와 병원의 시스템이 결과를 결정합니다. K.ARE는 암, 심혈관 등 고도의 기술력이 필요한 분야에 대해 국내 최상위 의료기관과의 신속한 진료 예약을 지원합니다.",
                    bullets: [
                        { title: "질환별 특화 매칭", desc: "종양, 심혈관, 척추, 난임 등 전문적인 케어가 필요한 진료 과목에 대해 검증된 교수진을 중심으로 의료팀 구성을 조율합니다." },
                        { title: "체계적인 사후 관리", desc: "치료 후 안정적인 회복과 일상 복귀를 위해, 과학적 근거에 기반한 후속 관리 로드맵을 설계해 드립니다." },
                    ],
                },
                {
                    part: "PART 03",
                    name: "프리미엄 에스테틱 & 성형 수술",
                    intro: "개별 맞춤 큐레이션으로 실현하는 본연의 아름다움. 대한민국은 글로벌 에스테틱 혁신의 중심입니다. K.ARE는 단순한 유행을 따르는 시술이 아닌, 개인의 해부학적 조화와 자연스러운 결과를 지향하는 국내 최정상급 전문의 라인업을 엄선하여 연결합니다.",
                    bullets: [
                        { title: "개인별 에스테틱 플랜 설계", desc: "안면 리바이탈라이징, 바디 컨투어링 등 개인의 고유한 비율을 고려하여 파트너 기관과 함께 최적의 시술 플랜을 조율합니다." },
                        { title: "에스테틱 매니지먼트", desc: "모든 시술은 검증된 의료 시설에서 진행되며, 일상으로의 신속한 복귀를 돕는 체계적인 사후 관리에 집중합니다." },
                    ],
                },
                {
                    part: "PART 04",
                    name: "전담 컨시어지",
                    intro: "체류 기간 전체를 관리하는 밀착 서포트. 한국에서의 일정은 번거로운 절차 없이 오직 안락함으로 채워져야 합니다. 전담 컨시어지 팀이 입국부터 귀국까지, 의료 여정을 포함하여 체류 중 발생하는 모든 필요 사항을 세심하게 관리함으로써 귀하가 치유와 회복에만 집중할 수 있는 최적의 환경을 지원합니다.",
                    bullets: [
                        { title: "VIP 의전 차량 서비스", desc: "전문 쇼퍼가 운전하는 전용 차량을 통해 공항 및 병원 이동 시 안전하고 편안한 이동 환경을 보장합니다." },
                        { title: "의료 전문 리에종", desc: "의학적 전문성과 환자의 이해 사이를 잇는 숙련된 통역 전문가가 진료 과정에 동행하여 명확한 소통을 지원합니다." },
                    ],
                },
                {
                    part: "PART 05",
                    name: "프라이빗 & 패키지 투어",
                    intro: "의료 일정에 최적화된 프라이빗 투어. 복잡한 계획 없이도 한국에서의 시간을 가치 있게 보낼 수 있도록 지원합니다. 모든 여행 프로그램은 귀하의 컨디션과 진료 일정을 최우선으로 고려하여 유연하게 설계되며, 일반적인 관광객은 접하기 어려운 특별한 경험을 제공합니다.",
                    bullets: [
                        { title: "시그니처 패키지", desc: "서울의 도심 매력부터 부산의 역동적인 바다까지, 한국의 상징적인 도시들을 프라이빗하게 경험하는 패키지입니다. 엄선된 럭셔리 숙소와 지역별 랜드마크 투어가 포함됩니다." },
                        { title: "단독 맞춤 투어", desc: "단독 요트 투어, 미쉐린 스타 다이닝, 숲속 프라이빗 휴양 등 귀하와 가족만을 위한 전용 일정을 기획하고 운영합니다." },
                        { title: "문화 체험", desc: "백화점 VIP 의전 쇼핑 및 유적지 단독 관람은 물론, 프라이빗 한식 클래스, 전통문화 및 공예 체험 등 한국의 정수를 깊이 있게 경험할 수 있는 독점적인 기회를 제공합니다." },
                    ],
                },
            ],
        },
        serviceList: {
            title: "서비스 항목",
            cards: [
                { title: "숙소 큐레이션", desc: "환자의 컨디션과 체류 목적에 최적화된 엄선된 숙박 시설을 연결합니다. 5성급 호텔, 하이엔드 레지던스, 장기 체류형 숙소" },
                { title: "맞춤 투어 서비스", desc: "진료 일정과 유기적으로 연결되는 고품격 여행 프로그램을 운영합니다. 시그니처 패키지 투어, 프라이빗 단독 투어" },
                { title: "의료 서비스 연계", desc: "국내 최정상급 의료기관과의 신속하고 정확한 진료 연계를 지원합니다. 피부과 및 에스테틱, 종합 정밀 검진, 전문의 중증 치료, 줄기세포 및 안티에이징, 치과 전문 케어, 바디 컨투어링, 성형외과, 난임 및 여성 건강" },
                { title: "전문 통번역", desc: "단순 언어 전달을 넘어 의학적 맥락까지 정확하게 전달하는 전문가가 동행합니다. 실시간 비대면 상담, 현장 밀착 의전 통역" },
            ],
        },
        faq: {
            title: "FAQ",
            items: [
                { q: "왜 한국에서 의료 치료를 받아야 하나요?", a: "한국은 세계 최고 수준의 의료 기술과 임상 경험, 효율적인 시스템을 합리적인 비용으로 제공합니다." },
                { q: "파트너 병원은 어떤 기준으로 고르나요?", a: "보건복지부 인증 상급종합병원 및 분야별 전문 센터를 중심으로 엄격한 기준에 따라 파트너사를 선정합니다. 임상 성공률, 응급 의료 체계, 외국인 환자 전용 인프라 등 자체 검증 절차를 통과한 신뢰할 수 있는 기관만을 연결해 드립니다." },
                { q: "K.ARE를 이용하는 것이 직접 예약하는 것보다 비용이 더 발생하나요?", a: "아니오, 그렇지 않습니다. 한국 의료법에 따라 외국인 환자에게 적용되는 의료 수가는 투명하게 규제되며, 귀하는 병원의 공식 수가를 동일하게 지불합니다. 다만, K.ARE가 제공하는 프리미엄 숙소 큐레이션, 맞춤형 투어, 추가 컨시어지 서비스 이용에 따른 별도의 패키지 비용이 발생할 수 있습니다. K.ARE는 고객님이 개별적으로 관리하기 어려운 모든 체류 과정을 통합하여 최상의 편의를 지원합니다." },
                { q: "건강검진 비용에 대해 세금 환급을 받을 수 있나요?", a: "건강검진은 한국 내 면세 서비스에 해당하여 세금 환급 대상이 아닙니다. 단, 미용 목적의 성형이나 시술은 관련 법규에 따라 환급이 가능할 수 있으므로 상담 시 상세히 안내해 드립니다." },
                { q: "언어 장벽 문제는 어떻게 해결하나요?", a: "모든 진료 과정에 통역가가 동행하여 의료진과의 정확한 소통을 지원합니다. 언어와 문화의 장벽 없이 오직 치료와 회복에만 전념하실 수 있는 환경을 보장합니다." },
                { q: "공항 픽업과 이동 서비스가 제공되나요?", a: "네, 입국 즉시 전용 차량 서비스를 통해 공항에서 숙소 및 병원까지 안전하고 품격 있게 모십니다. 체류 기간 중 발생하는 모든 이동은 전문 쇼퍼가 운전하는 의전 차량으로 지원됩니다." },
                { q: "한국 방문 전 미리 상담을 받을 수 있나요?", a: "네, 적극 권장합니다. 사전 상담을 통해 최적의 병원 예약을 선점하고 효율적인 일정을 설계할 수 있습니다. 당사에는 한국어, 영어, 중국어, 아랍어 전문 인력이 상주하여 방문 전 단계부터 원활한 소통을 지원합니다." },
                { q: "체류 기간은 얼마나 필요한가요?", a: "검진은 2~3일, 수술/시술은 회복 및 실밥 제거를 위해 7~14일 이상을 권장합니다." },
                { q: "회복을 위해 어떤 숙소가 제공되나요?", a: "안정적인 회복에 최적화된 환경을 선별하여 제안 드립니다. 병원과의 접근성, 정숙성, 회복 지원 서비스 등을 고려하여 5성급 호텔부터 프리미엄 빌라까지 귀하의 요구에 부합하는 숙소를 매칭해 드립니다." },
            ],
        },
        contact: {
            title: "Contact us",
            email: "Isaackwon@spatialcore.ai",
            line: "+82-10-3211-1288",
            hq: "#216, 1-8, Chang-dong, Dobong-gu, Seoul, 01411, Republic of Korea",
            button: "메시지 보내기",
        },
    },

    // 2. 영어 데이터
    en: {
        hero: {
            line1: "The Standard of Care,",
            line2: "the Art of Integrity",
        },
        about: {
            title: "About Us",
            subtitle: "A Private Gateway to Medical Excellence.",
            desc1: "Navigating the world’s most advanced medical landscape requires more than a map - it requires a partner. K.ARE was established to bridge the gap between international patients and South Korea’s elite medical infrastructure.",
            desc2: "We don't just facilitate treatments; we manage your health journey with a focus on clinical safety and personal dignity. By curating a restricted network of government-certified institutions, we advocate for every patient to receive the highest standard of care through our vetted partners.",
            features: [
                {
                    icon: "/kare_img/2-1_img.png",
                    title: "Verified Network",
                    desc: "Every partner clinic and hospital is audited for clinical success rates and safety protocols.",
                },
                {
                    icon: "/kare_img/2-2_img.png",
                    title: "Unbiased Advocacy",
                    desc: "We work for you, not the hospital. Our guidance is honest, transparent, and patient-first.",
                },
                {
                    icon: "/kare_img/2-3_img.png",
                    title: "A Unified Experience",
                    desc: "One point of contact, one standard of excellence, across every medical discipline.",
                },
            ],
        },
        services: {
            title: "Services",
            parts: [
                {
                    part: "PART 01",
                    name: "Precision Diagnostics",
                    intro: "The Blueprint of Your Health. Knowledge is the most powerful tool in medicine. We facilitate access to Korea’s ultra-advanced diagnostic systems, utilizing AI-assisted imaging and comprehensive biomarker analysis to facilitate a thorough overview of your health through expert specialist analysis.",
                    bullets: [
                        { title: "Efficiency Reimagined", desc: "Full-body executive screenings completed in a single, streamlined day." },
                        { title: "Actionable Data", desc: "Clear, translated reports with follow-up consultations from leading internal medicine specialists." },
                    ],
                },
                {
                    part: "PART 02",
                    name: "Clinical Excellence (Treatment)",
                    intro: "Supporting Your Recovery with World-Class Science. When the stakes are highest, precision matters most. We connect you with the most reliable medical institutions in Korea and specialized centers known for world-leading survival rates in complex surgeries and their treatments.",
                    bullets: [
                        { title: "Specialized Treatment", desc: "Expert coordination for oncology, cardiology, spinal health, and fertility." },
                        { title: "Structured Aftercare Support", desc: "To facilitate stable recovery and a seamless return to daily life, we coordinate a science-backed post-treatment roadmap based on expert clinical guidance." },
                    ],
                },
                {
                    part: "PART 03",
                    name: "Aesthetic Artistry",
                    intro: "The Refinement of the Self. South Korea is the global capital of aesthetic innovation. We provide a discreet gateway to the nation’s most skilled surgeons and dermatologists who prioritize harmony and natural results over trends.",
                    bullets: [
                        { title: "Subtle Transformation", desc: "Tailored plans for facial rejuvenation, body contouring, and advanced skincare." },
                        { title: "Safety-First Approach", desc: "Partnering exclusively with institutions audited for their rigorous safety and sterility protocols, focusing on a path toward elegant recovery." },
                        { title: "Dermatological Science", desc: "Access the 'Gangnam Standard' of skin health through Korea’s leading researchers in laser and cellular rejuvenation." },
                    ],
                },
                {
                    part: "PART 04",
                    name: "The Concierge Collective",
                    intro: "Seamless Support, Felt at Every Step. Your journey should be defined by comfort, not logistics. Our concierge team handles the nuances of your stay so you can focus entirely on healing.",
                    bullets: [
                        { title: "Seamless Mobility", desc: "Private, chauffeur-driven airport transfers and clinic shuttles." },
                        { title: "Expert Liaisons", desc: "Professional medical translators who bridge the gap between technical nuance and your understanding." },
                        { title: "Lifestyle Coordination", desc: "From luxury accommodation sourcing to post-treatment nutritional care and 24/7 on-call assistance." },
                    ],
                },
                {
                    part: "PART 05",
                    name: "Curated Escapes (Private & Package Tours)",
                    intro: "Healing Through Discovery. We design bespoke travel experiences that complement your medical itinerary, ensuring a restful and enriching stay in Korea.",
                    bullets: [
                        { title: "Signature Destination Tours", desc: "Curated journeys through Korea’s most iconic cities, from the vibrant urban pulse of Seoul to the scenic coastlines of Busan, featuring luxury stays and hand-picked local landmarks." },
                        { title: "Private Curations", desc: "Tailored solo or family tours featuring private yacht excursions, Michelin-starred culinary journeys, and meditative forest retreats and more." },
                        { title: "Cultural Immersion", desc: "Discreet access to VIP shopping protocols and private heritage tours, as well as exclusive culinary masterclasses and traditional craft workshops, offering unique opportunities to experience the true essence of Korea." },
                    ],
                },
            ],
        },
        serviceList: {
            title: "Services lists",
            cards: [
                { title: "Accomoation", desc: "Hotel, Luxury stay, long-term stay" },
                { title: "Tour", desc: "Package tour plan, Private tour" },
                { title: "Medical Service", desc: "Dermatology & Aesthetics, Medical Checkup, Treatment, Stem Cell & Anti-Againg, Dental Care, Body Contouring, Plastic Surgery, Fertility&Women’s health" },
                { title: "Translation, Interpretation", desc: "Online Translation, Offline Interpretation, VIP Concierge" },
            ],
        },
        faq: {
            title: "FAQ",
            items: [
                { q: "Why should I choose Korea for my medical treatment? ", a: "South Korea represents the global pinnacle of medical efficiency and technology. Whether it is the world-leading survival rates for oncology or the unparalleled precision of aesthetic surgery, Korea offers a level of care that combines advanced robotic technology with high-volume clinical experience, often at a more accessible value than in the US or Europe." },
                { q: "How does K.ARE select its partner hospitals?", a: "We do not partner with every clinic. K.ARE maintains a strictly curated network of 'Tertiary General Hospitals' and specialized centers accredited by the Ministry of Health and Welfare. We perform independent audits focusing on clinical success rates, the presence of emergency medical teams, and the quality of their international patient infrastructure." },
                { q: "Is using K.ARE more expensive than booking directly?", a: "No. Under Korean law, medical fees for international patients are regulated. You pay the official hospital rate. However, depending on your selection of premium concierge services—such as accommodation, bespoke tours, and private transport—additional package fees may apply. K.ARE adds value by integrating all the complex logistics of your stay into a single, seamless experience." },
                { q: "Can I get tax refund for my health checkups?", a: "Health checkups are tax-exempt services, therefore not eligible for a tax refund." },
                { q: "How do I handle the language barrier?", a: "You will never be alone in a consultation. We’ll guide you through the steps of your first visit, providing essential details on when to go, how to get there, and what to bring. Rest assured, we work with English-speaking staff at the clinics who will assist you during your appointment to ensure clear communication with your medical team." },
                { q: "Do you provide airport pickup and transportation?", a: "Beyond simple transport, we provide a seamless mobility experience. Our private chauffeur service ensures you are met at the gate upon arrival and transported in comfort to your accommodation or clinic, anywhere in the country." },
                { q: "Can I have a consultation before I travel to Korea?", a: "We highly recommend it. An early consultation allows us to secure reservations at top-tier clinics and precisely schedule your stay to avoid any unnecessary delays. Beyond your medical needs, this advance dialogue enables us to design custom tours for you and your companions, recommending the finest hidden gems across Korea to make your journey as enriching as it is restorative. ﻿To ensure seamless communication from the very first step, we have dedicated English, Chinese, and Arabic-speaking staff available in our office to discuss your plan in the language you are most comfortable with." },
                { q: "How long should I plan to stay in Korea?", a: "The duration varies by procedure. For general checkups, 2–3 days are sufficient. For major surgeries or aesthetic procedures, we usually recommend 7–14 days or more to allow for initial recovery and the removal of stitches before you fly." },
                { q: "What kind of accommodation do you provide for recovery?", a: "We curate 'Healing Sanctuaries'—accommodations chosen for their tranquility, proximity to the clinic, and availability of recovery-friendly services. From 5-star hotels to specialized medical villas, we match the stay to your needs." },
            ],
        },
        contact: {
            title: "Contact us",
            email: "Isaackwon@spatialcore.ai",
            line: "+82-10-3211-1288",
            hq: "#216, 1-8, Chang-dong, Dobong-gu, Seoul, 01411, Republic of Korea",
            button: "Send a message",
        },
    },

    // 3. 아랍어 데이터
    ar: {
        hero: {
            line1: "شعارنا",
            line2: "معيار الرعاية، وفن النزاهة",
        },
        about: {
            title: "من نحن",
            subtitle: "بوابتكم الخاصة نحو التميز الطبي.",
            desc1: "إن التنقل في مشهد الطب الأكثر تطوراً في العالم يتطلب ما هو أكثر من مجرد خريطة؛ إنه يتطلب شريكاً موثوقاً. تأسست K.ARE لتكون الجسر الذي يربط المرضى الدوليين بنخبة البنية التحتية الطبية في كوريا الجنوبية.",
            desc2: "نحن لا نكتفي بتيسير العلاجات فحسب، بل ندير رحلتكم الصحية بتركيز مطلق على السلامة السريرية والكرامة الشخصية. ومن خلال اختيارنا لشبكة حصرية من المؤسسات المعتمدة حكومياً، فإننا نسعى لضمان حصول كل مريض على أعلى معايير الرعاية من خلال شركائنا المعتمدين.",
            features: [
                {
                    icon: "/kare_img/2-1_img.png",
                    title: "شبكة موثقة",
                    desc: "تخضع كل عيادة ومستشفى شريك لتدقيق صارم يشمل معدلات النجاح السريري وبروتوكولات السلامة.",
                },
                {
                    icon: "/kare_img/2-2_img.png",
                    title: "تمثيل مستقل ومخلص",
                    desc: "نحن نعمل لأجلك أنت، لا لصالح المستشفى. توجيهاتنا صادقة، شفافة، وتضع المريض أولاً.",
                },
                {
                    icon: "/kare_img/2-3_img.png",
                    title: "تجربة موحدة",
                    desc: "نقطة اتصال واحدة، ومعيار واحد للتميز، عبر كافة التخصصات الطبية.",
                },
            ],
        },
        services: {
            title: "الخدمات",
            parts: [
                {
                    part: "PART 01",
                    name: "التشخيص الدقيق",
                    intro: "المخطط التفصيلي لصحتك. المعرفة هي أقوى أداة في الطب. نحن نيسر وصولكم إلى أنظمة التشخيص فائقة التطور في كوريا، والتي تعتمد على التصوير المدعوم بالذكاء الاصطناعي وتحليل المؤشرات الحيوية الشامل، لتقديم نظرة وافية عن حالتكم الصحية من خلال تحليلات الخبراء والمتخصصين.",
                    bullets: [
                        { title: "إعادة تعريف الكفاءة", desc: "فحص شامل للجسم يُنجز في يوم واحد ومنظم بعناية." },
                        { title: "بيانات قابلة للتنفيذ", desc: "تقارير واضحة ومترجمة مع استشارات متابعة من كبار أخصائيي الطب الباطني." },
                    ],
                },
                {
                    part: "PART 02",
                    name: "التميز السريري (العلاج)",
                    intro: "دعم تعافيكم بأحدث العلوم العالمية. عندما تكون الصحة هي الأولوية، تصبح الدقة هي المطلب الأهم. نحن نصلكم بأكثر المؤسسات الطبية موثوقية في كوريا، وبالمراكز المتخصصة المشهود لها عالمياً بأعلى معدلات النجاة في العمليات الجراحية المعقدة وعلاجاتها.",
                    bullets: [
                        { title: "علاجات متخصصة", desc: "تنسيق خبير في مجالات الأورام، أمراض القلب، صحة العمود الفقري، والخصوبة." },
                        { title: "دعم منظم لما بعد العلاج", desc: "لضمان تعاف مستقر وعودة سلسة إلى الحياة اليومية، نقوم بتنسيق خارطة طريق لما بعد العلاج مبنية على أسس علمية وتوجيهات سريرية خبيرة." },
                    ],
                },
                {
                    part: "PART 03",
                    name: "البراعة الجمالية",
                    intro: "رقي الذات. تعد كوريا الجنوبية العاصمة العالمية للابتكار الجمالي. نحن نوفر لكم بوابة سرية لأمهر الجراحين وأطباء الجلد الذين يولون الأولوية للتناغم والنتائج الطبيعية بعيداً عن الصيحات العابرة.",
                    bullets: [
                        { title: "تحول متقن", desc: "خطط مخصصة لتجديد شباب الوجه، نحت القوام، والعناية المتقدمة بالبشرة." },
                        { title: "نهج السلامة أولاً", desc: "الشراكة حصرياً مع المؤسسات التي خضعت للتدقيق في بروتوكولات التعقيم والسلامة الصارمة، مع التركيز على مسار تعاف أنيق." },
                        { title: "علوم الأمراض الجلدية", desc: "الوصول إلى معيار \"غانغنام\" لصحة الجلد من خلال كبار الباحثين في كوريا في مجالات الليزر وتجديد الخلايا." },
                    ],
                },
                {
                    part: "PART 04",
                    name: "مجموعة الخدمات المساندة (Concierge)",
                    intro: "دعم سلس، تشعر به في كل خطوة. يجب أن تتسم رحلتك بالراحة لا بالتعقيدات اللوجستية. يتولى فريقنا المختص إدارة كافة تفاصيل إقامتكم لتتمكنوا من التركيز تماماً على الشفاء.",
                    bullets: [
                        { title: "نقل متكامل", desc: "سيارات خاصة مع سائق لنقلكم من المطار وإلى العيادات." },
                        { title: "تواصل خبير", desc: "مترجمون طبيون محترفون يزيلون الفجوة بين التفاصيل التقنية الدقيقة واستيعابكم الكامل للحالة." },
                        { title: "تنسيق نمط الحياة", desc: "من تأمين أماكن الإقامة الفاخرة إلى الرعاية الغذائية ما بعد العلاج والمساعدة المتاحة على مدار الساعة." },
                    ],
                },
                {
                    part: "PART 05",
                    name: "برنامج خاص (جولات خاصة وباقات سياحية)",
                    intro: "الاستشفاء عبر الاستكشاف. نصمم تجارب سفر مخصصة تكمل جدولكم الطبي، مما يضمن لكم إقامة مريحة ومثرية في كوريا.",
                    bullets: [
                        { title: "جولات الوجهات المميزة", desc: "رحلات منسقة عبر المدن الكورية الأكثر شهرة، من نبض سيول الحضري إلى سواحل بوسان الخلابة، مع إقامات فاخرة ومعالم مختارة بعناية." },
                        { title: "تنسيقات خاصة", desc: "جولات مخصصة للأفراد أو العائلات تشمل نزهات باليخوت الخاصة، رحلات طهي في مطاعم حائزة على نجمة ميشلان، وتجارب استرخاء في الغابات الهادئة." },
                        { title: "انغماس ثقافي", desc: "وصول حصري لبروتوكولات التسوق لكبار الشخصيات (VIP) ، جولات التراث الخاص، وورش عمل الحرف التقليدية، مما يتيح فرصاً فريدة لتجربة الجوهر الحقيقي لكوريا." },
                    ],
                },
            ],
        },
        serviceList: {
            title: "قائمة الخدمات",
            cards: [
                { title: "الإقامة", desc: "فنادق إقامات فاخرة، إقامات طويلة الأمد." },
                { title: "السياحة", desc: "خطط جولات سياحية شاملة جولات خاصة." },
                { title: "الخدمات الطبية", desc: "الجلدية والتجميل الفحص الطبي الشامل العلاج السريري، الخلايا الجذعية ومكافحة الشيخوخة، طب الأسنان، نحت القوام، الجراحة التجميلية، الخصوبة وصحة المرأة." },
                { title: "الترجمة", desc: "ترجمة المستندات عبر الإنترنت ترجمة فورية ميدانية، خدمات الكونسيرج لكبار الشخصيات." },
            ],
        },
        faq: {
            title: "الأسئلة الشائعة",
            items: [
                { q: "س: لماذا أختار كوريا لتلقي علاجي الطبي؟", a: "ج: تمثل كوريا الجنوبية القمة العالمية في كفاءة التكنولوجيا الطبية. وسواء تعلق الأمر بمعدلات النجاة الرائدة عالمياً في علاج الأورام أو الدقة منقطعة النظير في الجراحات التجميلية، توفر كوريا مستوى من الرعاية يجمع بين التكنولوجيا الروبوتية المتقدمة والخبرة السريرية الواسعة، وغالباً بقيمة تنافسية تفوق نظيراتها في الولايات المتحدة أو أوروبا." },
                { q: "س: كيف تختار KARE المستشفيات الشريكة؟", a: "ج: نحن لا نتعاقد مع كل العيادات. تحافظ KARE على شبكة مختارة بدقة من المستشفيات العامة الجامعية والمراكز المتخصصة المعتمدة من وزارة الصحة والرعاية الاجتماعية. نقوم بإجراء عمليات تدقيق مستقلة تركز على معدلات النجاح السريري، وتوافر فرق الطوارئ الطبية، وجودة البنية التحتية المخصصة للمرضى الدوليين." },
                { q: "س: هل استخدام خدمات KARE أكثر تكلفة من الحجز المباشر؟", a: "ج: لا بموجب القانون الكوري، يتم تنظيم الرسوم الطبية للمرضى الدوليين؛ لذا ستدفع السعر الرسمي للمستشفى. ومع ذلك، قد تُطبق رسوم إضافية على باقات الخدمات المتميزة مثل الإقامة الجولات المخصصة، والنقل الخاص. تضيف K.ARE قيمة من خلال دمج كافة الخدمات اللوجستية المعقدة في تجربة واحدة سلسة." },
                { q: "س: هل يمكنني الحصول على استرداد ضريبي للفحوصات الطبية؟", a: "ج: تعتبر الفحوصات الطبية خدمات معفاة من الضرائب، وبالتالي فهي غير مؤهلة للاسترداد الضريبي." },
                { q: "س: كيف يمكنني التعامل مع حاجز اللغة؟", a: "ج: لن تكونوا وحدكم أبداً أثناء الاستشارة سنوجهكم عبر خطوات زيارتكم الأولى، ونوفر التفاصيل الأساسية حول المواعيد وطرق الوصول. كن على ثقة بأننا نعمل مع طاقم يتحدث الإنجليزية في العيادات، بالإضافة إلى مرافقتنا لكم لضمان تواصل واضح ودقيق مع الفريق الطبي." },
                { q: "س: هل توفرون خدمة الاستقبال من المطار والتنقلات؟", a: "ج: أبعد من مجرد النقل، نحن نقدم تجربة تنقل متكاملة تضمن خدمة السائق الخاص لدينا استقبالكم عند بوابة الوصول ونقلكم بكل راحة إلى مكان إقامتكم أو العيادة في أي مكان داخل البلاد." },
                { q: "س: هل يمكنني الحصول على استشارة قبل السفر إلى كوريا؟", a: "ج: نوصي بشدة بذلك. تتيح لنا الاستشارة المبكرة تأمين الحجوزات في العيادات الكبرى وجدولة إقامتكم بدقة لتجنب أي تأخير. وبالإضافة إلى احتياجاتكم الطبية، يتيح لنا هذا الحوار المسبق تصميم جولات مخصصة لكم ولمرافقيك، مع التوصية بأجمل الوجهات الخفية في كوريا لتكون رحلتكم علاجية ومثرية في آن واحد. ولضمان تواصل سلس منذ الخطوة الأولى، يتوفر في مكتبنا موظفون متخصصون يتحدثون الإنجليزية الصينية، والعربية لمناقشة خطتكم باللغة التي تفضلونها." },
                { q: "س: ما هي المدة التي يجب أن أخطط لقضائها في كوريا؟", a: "ج: تختلف المدة حسب الإجراء الطبي. للفحوصات العامة، يكفي يومان إلى ثلاثة أيام بالنسبة للجراحات الكبرى أو العمليات التجميلية، نوصي عادة بـ 7 إلى 14 يوماً أو أكثر للسماح بالتعافي الأولي وإزالة الغرز قبل السفر." },
                { q: "س: ما نوع الإقامة التي توفرونها لفترة التعافي؟", a: "ج: نحن نختار \"منتجعات الاستشفاء\" بعناية؛ وهي أماكن إقامة تم اختيارها لهدوئها، وقربها من العيادات، وتوفر الخدمات المناسبة للتعافي من فنادق الخمس نجوم إلى الفيلات الطبية المتخصصة، نحن نوائم الإقامة مع احتياجاتكم الخاصة." },
            ],
        },
        contact: {
            title: "للتواصل",
            email: "Isaackwon@spatialcore.ai",
            line: "+82-10-3211-1288",
            hq: "#216, 1-8, Chang-dong, Dobong-gu, Seoul, 01411, Republic of Korea",
            button: "إرسال رسالة",
        },
    },
}; 

const PART_IMAGES = [
    "/kare_img/part01_img.png",
    "/kare_img/part02_img.jpg",
    "/kare_img/part03_img.jpg",
    "/kare_img/part04_img.jpg",
    "/kare_img/part05_img.jpg",
];

function Kare({ lang = "ko" }) {
    const kareLang = lang;
    
    // [기존 유지] About Us 스크롤 관련 상태
    const aboutTrackRef = useRef(null);
    const [progress, setProgress] = useState(0);

    // FAQ는 다중 항목 오픈 상태를 허용
    const [openFaqIndexes, setOpenFaqIndexes] = useState([]);
    // Contact 버튼 클릭 시 작은 번호 노출
    const [showContactNumber, setShowContactNumber] = useState(false);
    const [stickyBaseTop, setStickyBaseTop] = useState(150);

    // [기존 유지] About Us 스크롤 계산 로직
    useEffect(() => {
        const handleScroll = () => {
            if (!aboutTrackRef.current) return;
            
            const rect = aboutTrackRef.current.getBoundingClientRect();
            const trackHeight = rect.height;
            const viewHeight = window.innerHeight;
            const scrollableDistance = trackHeight - viewHeight;
            const scrolled = -rect.top; 

            let ratio = 0;
            if (scrolled > 0) {
                ratio = scrolled / scrollableDistance;
            }
            ratio = Math.max(0, Math.min(1, ratio));
            setProgress(ratio * 145);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        setOpenFaqIndexes([]);
        setShowContactNumber(false);
    }, [kareLang]);

    // Services sticky 기준을 화면 높이에 맞춰 동적으로 보정
    useEffect(() => {
        const updateStickyBaseTop = () => {
            const vh = window.innerHeight || 900;
            const dynamicBase = Math.round(vh * 0.09);
            // 너무 낮거나 높지 않게 클램프
            const nextBase = Math.max(64, Math.min(110, dynamicBase));
            setStickyBaseTop(nextBase);
        };

        updateStickyBaseTop();
        window.addEventListener("resize", updateStickyBaseTop);
        return () => window.removeEventListener("resize", updateStickyBaseTop);
    }, []);

    const current = KARE_TEXT[kareLang] || KARE_TEXT.ko;
    const isArabic = kareLang === "ar";
    const isKorean = kareLang === "ko";

    const handleFaqToggle = (idx) => {
        setOpenFaqIndexes((prev) => {
            if (prev.includes(idx)) {
                return prev.filter((item) => item !== idx);
            }
            return [...prev, idx];
        });
    };

    const handleScrollToAbout = () => {
        if (!aboutTrackRef.current) return;
        aboutTrackRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <main className={`kare-page ${isArabic ? "kare-arabic-mode" : ""}`} dir={isArabic ? "rtl" : "ltr"}>
            
            <section className="kare-section kare-section-1">
                <div className="kare-hero-wrap">
                    <img src="/kare_img/Kare_women_image.png" alt="Hero" className="kare-hero-image" />
                    <div className="kare-hero-overlay">
                        <h1>{current.hero.line1}<br />{current.hero.line2}</h1>
                    </div>
                    <button
                        type="button"
                        className="kare-hero-scroll-btn"
                        onClick={handleScrollToAbout}
                        aria-label="Scroll to About Us section"
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <polyline points="6 9 12 15 18 9" stroke="currentColor" strokeWidth="2" />
                        </svg>
                    </button>
                </div>
            </section>

            {/* 2. About Us 섹션 JSX 구조 */}
            <section className="kare-about-scroll-track" ref={aboutTrackRef}>
                <div className="kare-about-sticky-wrap">
                    <div className="kare-about-inner">
                        <h2 className="kare-about-title">{current.about.title}</h2>
                        <p className="kare-about-subtitle">{current.about.subtitle}</p>
                        
                        <div className="kare-about-desc-wrap">
                            <p>{current.about.desc1}</p>
                            <p>{current.about.desc2}</p>
                        </div>

                        <div className="kare-timeline-container">
                            {/* 배경 회색 선 */}
                            <div className="kare-timeline-base-line"></div>
                            {/* 채워지는 색상 선 (progress width로 제어) */}
                            <div 
                                className="kare-timeline-fill-line" 
                                style={{ width: `${progress}%` }}
                            ></div>

                            {/* 3개 노드 */}
                            <div className="kare-timeline-nodes">
                                {current.about.features.map((feature, idx) => {
                                    // 라인이 각 노드를 지나는 시점에 맞춰 단계적으로 활성화
                                    // (진행률은 0~145 범위로 계산됨)
                                    const triggerPoints = [30, 70, 100];
                                    const trigger = triggerPoints[idx] ?? 999;
                                    const isActive = progress > trigger;

                                    return (
                                        <div key={idx} className={`kare-node-item ${isActive ? "active" : ""}`}>
                                            <div className="kare-node-circle">
                                                <img src={feature.icon} alt={feature.title} />
                                            </div>
                                            <div className="kare-node-text">
                                                <h3>{feature.title}</h3>
                                                <p>{feature.desc}</p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 3. Services 섹션 */}
            <section className="kare-services-stack-container">
                {/* 메인 타이틀 (스크롤 시 사라짐) */}
                <div className="kare-services-main-header">
                    <h2 className="kare-services-title">{current.services.title}</h2>
                </div>

                <div className="kare-services-cards-wrapper">
                    {current.services.parts.map((part, idx) => {
                        // [핵심] Sticky Top 위치 계산
                        // 상단 여백(150px) + (인덱스 * 노출될 헤더 높이 60px)
                        // 이렇게 하면 스크롤 시 카드가 겹칠 때 상단 60px씩 남기고 차곡차곡 쌓임
                        const stickyTop = stickyBaseTop + (idx * 60);

                        return (
                            <article 
                                key={idx} 
                                className="kare-service-card-item"
                                style={{ top: `${stickyTop}px` }} 
                            >
                                {/* [추가됨] 카드 상단 헤더 (겹칠 때 보이는 부분) */}
                                <div className="kare-service-card-header">
                                    <span className="kare-service-part-badge">{part.part}</span>
                                </div>
                                
                                <div className="kare-services-inner">
                                    <div className="kare-service-copy">
                                        {/* 기존 PART 라벨은 위 헤더로 옮겼으므로 여기서는 제거하거나 유지해도 됨 (디자인 선택) */}
                                        {/* <p className="kare-service-part-label">{part.part}</p> */} 
                                        
                                        <h3 className="kare-service-name">{part.name}</h3>
                                        <p className="kare-service-intro">{part.intro}</p>
                                        <div className="kare-service-bullet-list">
                                            {part.bullets.map((b, i) => (
                                                <div className="kare-service-bullet" key={i}>
                                                    <h4>{b.title}</h4>
                                                    <p>{b.desc}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="kare-service-image-wrap">
                                        <img src={PART_IMAGES[idx] || PART_IMAGES[0]} alt={`service visual ${idx + 1}`} />
                                    </div>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </section>
            
            {/* 4. Service List 섹션 */}
            <section className="kare-section kare-section-4">
                <div className="kare-list-inner">
                    <h2>{current.serviceList.title}</h2>
                    <div className="kare-list-grid">
                        {current.serviceList.cards.map((card, i) => (
                            <article key={i} className="kare-list-card">
                                <h3>{card.title}</h3>
                                <p>{card.desc}</p>
                            </article>
                        ))}
                    </div>
                </div>
            </section>
            
            {/* 5. FAQ 섹션 */}
            <section className="kare-section kare-section-5">
                <div className="kare-faq-inner">
                    <h2>{current.faq.title}</h2>
                    <div className="kare-faq-list">
                        {current.faq.items.map((item, idx) => {
                            const isOpen = openFaqIndexes.includes(idx);
                            return (
                                <div className={`kare-faq-item ${isOpen ? "open" : ""}`} key={idx}>
                                    <button className="kare-faq-question" onClick={() => handleFaqToggle(idx)}>
                                        <span>{item.q}</span>
                                        <span className="kare-faq-plus">{isOpen ? "-" : "+"}</span>
                                    </button>
                                    <div className="kare-faq-answer"><p>{item.a}</p></div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>

            {/* 6. Contact us 섹션 (한국어는 해당 영역 제외) */}
            {!isKorean && (
                <section className="kare-section kare-section-6">
                    <div className="kare-contact-inner">
                        <h2>{current.contact.title}</h2>
                        <div className="kare-contact-card">
                            <div className="kare-contact-item">
                                <p className="kare-contact-label">E-mail</p>
                                <p className="kare-contact-value">{current.contact.email}</p>
                            </div>
                            <div className="kare-contact-item">
                                <p className="kare-contact-label">Headquarters</p>
                                <p className="kare-contact-value">{current.contact.hq}</p>
                            </div>
                            <div className="kare-contact-action">
                                <button
                                    type="button"
                                    className="kare-contact-btn"
                                    onClick={() => setShowContactNumber((prev) => !prev)}
                                >
                                    {current.contact.button}
                                </button>
                                {showContactNumber && (
                                    <div className="kare-contact-mini-number" role="status" aria-live="polite">
                                        <p>{current.contact.line}</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </main>
    );
}

export default Kare;